module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGamesJoined/mlb/survive-630e021e818dc2d60992ac1eea70ebd7.svg";